import { RendererBaseProps } from '../index';
import { ImagePage } from './image-page';

type ImageRendererProps = RendererBaseProps & {
  zoom: number;
  getBasePageDimensions: (pageNumber: number) => { height: number; width: number };
};

export const ImageRenderer = ({
  docId,
  getPageDimensions,
  getBasePageDimensions,
  zoom,
  visiblePages,
  getPagePosition,
  highlights,
  highlightedFactId,
  onHighlightClick,
  highlightedChunkId,
  searchQuery,
  focusedMatch,
  totalHeight,
  maxPageWidth: providedMaxPageWidth,
  isSelectionMode,
  onSelectionComplete,
  maintainSelection,
  activeSelection,
}: ImageRendererProps) => {
  // Use provided maxPageWidth if available, otherwise calculate from visible pages
  // Using the provided value (calculated from ALL pages) prevents horizontal scroll jumps
  // when new pages with different widths come into view
  const maxPageWidth =
    providedMaxPageWidth ??
    visiblePages.reduce((max, pageNumber) => {
      const pageDims = getPageDimensions(pageNumber);
      return Math.max(max, pageDims.width);
    }, 0);

  // Add padding (20px on each side) for the grey border
  const containerWidth = maxPageWidth + 40;

  return (
    <div className="relative bg-gray-100" style={{ height: totalHeight, width: containerWidth, minWidth: '100%' }}>
      {visiblePages.map((pageNumber) => {
        const basePageDims = getBasePageDimensions(pageNumber);

        return (
          <ImagePage
            key={pageNumber}
            pageNumber={pageNumber}
            top={getPagePosition(pageNumber)}
            baseDimensions={{ height: basePageDims.height, width: basePageDims.width }}
            zoom={zoom}
            highlights={highlights}
            highlightedFactId={highlightedFactId}
            onHighlightClick={onHighlightClick}
            highlightedChunkId={highlightedChunkId}
            searchQuery={searchQuery}
            focusedMatch={focusedMatch}
            docId={docId}
            isSelectionMode={isSelectionMode}
            onSelectionComplete={onSelectionComplete}
            maintainSelection={maintainSelection}
            activeSelection={activeSelection}
          />
        );
      })}
    </div>
  );
};
